import { ResponseTermsAndConditionsManagerCreate, RequestTermsAndConditionsManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { TermsAndConditionsManagerCreateActions } from '../actions';
import { TermsAndConditionsManagerCreateTypes } from '../../shared/enums';

export interface TermsAndConditionsManagerCreateState {
    response: ResponseTermsAndConditionsManagerCreate;
    request: RequestTermsAndConditionsManagerCreate;
    error: any;
}

export const TermsAndConditionsManagerCreateInitialState: TermsAndConditionsManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _termsAndConditionsManagerCreateReducer = createReducer(
    TermsAndConditionsManagerCreateInitialState,

    on(TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(TermsAndConditionsManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function termsAndConditionsManagerCreateReducer(state, action) {
    if (action.type === TermsAndConditionsManagerCreateTypes.TERMS_AND_CONDITIONS_MANAGER_CREATE) {
        state = undefined;
    }
    return _termsAndConditionsManagerCreateReducer(state, action);
}
